import { type IOffer } from "../../../../store/slices/offersSlice";



export const filterAndSortOffers = (unit: any, task : IOffer,  sortType :Record<string, any>): boolean => {
    
    const sortByStatus =  sortType.byOfferStatus 
    const sortByOfferGroups = sortType.byOfferGroups as string[]
    const sortByTypeUnit = sortType.sortByTypeUnit
    const statuses = task?.attributes?.Statuses as any[]; 
    const isArray = Array.isArray(task?.attributes?.Statuses)
    const sortByUnitID = sortType.unitID
    
    const statusMatch = sortByOfferGroups?.includes('all') || sortByOfferGroups?.includes(statuses[0])
    const idMatch = !sortByUnitID || Number(sortByUnitID) === Number(unit?.id);
      
       
    if (!statusMatch) return false;
    if (!idMatch) return false;

    if (sortByTypeUnit === 'all') return true;
    if (sortByTypeUnit === 'sale') return unit?.attributes?.Marketing?.Use === 'For sale';
    if (sortByTypeUnit === 'rent') return unit?.attributes?.Marketing?.Use === 'For rent';
    return false;
};